import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Wait extends Component {
  constructor(props) {
    super(props);

    this.activateButton = this.activateButton.bind(this);
    this.deactivateButton = this.deactivateButton.bind(this);

    this.state = {
      isButtonActive: false
    };
  }

  componentDidMount() {
    const { history } = this.props;
    setTimeout(() => {
      history.push('/test/10');
    }, 2000);
  }

  activateButton() {
    this.setState({
      isButtonActive: true
    });
  }

  deactivateButton() {
    this.setState({
      isButtonActive: false
    });
  }

  render() {
    return (
      <div className="container pos-abs margin-top-xl">
        <div className="row">
          <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 text-center">
            <div className="dialog dialog-bubble">
              <h2 className="margin-no">等等！忘了還有一題！</h2>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Wait.propTypes = {
  history: PropTypes.shape().isRequired
};

export default Wait;



// WEBPACK FOOTER //
// ./app/components/Wait.js